class administradorService {//servicios para login
  axios
  baseUrl

  constructor(axios, baseUrl) {
    this.axios = axios;
    this.baseUrl = `${baseUrl}`;
  }

  // crud limite iva-ros
  getLimitIVA() {
    return this.axios.get(`${this.baseUrl}/limiteiva/listado`)
  }
  postLimitIVA(body) {
    let url = `${this.baseUrl}/limiteiva/insertar`
    return this.axios.post(url, body)
  }
  deleteLimitIVA(id) {
    return this.axios.delete(`${this.baseUrl}/limiteiva/eliminar/${id}`)
  }

  // crud limite isr-ros
  getLimitISR() {
    return this.axios.get(`${this.baseUrl}/limiteisr/listado`)
  }
  postLimitISR(body) {
    let url = `${this.baseUrl}/limiteisr/insertar`
    return this.axios.post(url, body)
  }
  deleteLimitISR(id) {
    return this.axios.delete(`${this.baseUrl}/limiteisr/eliminar/${id}`)
  }

  getUsuarios() {
    return this.axios.get(`${this.baseUrl}/usuario/listado`)
  }

  getUsuariosRos() {
    return this.axios.get(`${this.baseUrl}/usuario/listado/ros`)
  }

  obtenerCierreAnualISR(anio,usuario_id){
    let url = `${this.baseUrl}/reporte/general/${usuario_id}/${anio}`
    return this.axios.get(url);
  }

  updateEmpleados(body) {
    return this.axios.put(`${this.baseUrl}/usuario/empleado`, body)
  }

  getTiposSuscripcion(regimen_id) {
    return this.axios.get(`${this.baseUrl}/tipo_suscripcion/listado/${regimen_id}`)
  }

  insertarTipoSuscripcion(body) {
    let url = `${this.baseUrl}/tipo_suscripcion/insertar`
    return this.axios.post(url, body)
  }

  actualizarTipoSuscripcion(body) {
    let url = `${this.baseUrl}/tipo_suscripcion/actualizar`
    return this.axios.put(url, body)
  }

  desactivarTipoSuscripcion(body) {//activa o desactiva
    let url = `${this.baseUrl}/tipo_suscripcion/desactivar`
    return this.axios.delete(url, { data: body })
  }

  getTiposSuscripcionActivas(regimen_id) {
    return this.axios.get(`${this.baseUrl}/tipo_suscripcion/activas/${regimen_id}`)
  }

  getRangosFecha() {
    return this.axios.get(`${this.baseUrl}/rango/index`)
  }

  putActualizarRangosFecha(body) {
    let url = `${this.baseUrl}/rango/actualizar`
    return this.axios.put(url, body)
  }

  putActualizarDiaDeclaracion(body) {
    let url = `${this.baseUrl}/usuario/dia_declaracion`
    return this.axios.put(url, body)
  }

  getListadoEmpleados() {
    return this.axios.get(`${this.baseUrl}/usuario/listado/empleado`)
  }

  getRegimenListado() {
    return this.axios.get(`${this.baseUrl}/regimen/listado`)
  }

  putActualizarRegimen(body) {
    let url = `${this.baseUrl}/regimen/actualizar`
    return this.axios.put(url, body)
  }

  postInsertarRegimen(body) {
    let url = `${this.baseUrl}/regimen/insertar`
    return this.axios.post(url, body)
  }

  // retenedores agentes IVA
  listadoCargaRetenedoresIVA() {
    let url = `${this.baseUrl}/retenedores/agentes/archivos-cargados`
    return this.axios.get(url)
  }

  postInsertaRetenedoresIVA(body) {
    let url = `${this.baseUrl}/carga-masiva/retenedores/insertar`
    return this.axios.post(url, body)
  }

  postInsertarRetenedorIndividualIVA(body) {
    let url = `${this.baseUrl}/retenedores/individual/insertar`
    return this.axios.post(url, body)
  }

  actualizarRetenedorIndividualIVA(body) {
    let url = `${this.baseUrl}/retenedores/actualizar`
    return this.axios.put(url, body)
  }

  eliminarRetenedorIndividualIVA(body) {
    let url = `${this.baseUrl}/retenedores/eliminar`
    return this.axios.delete(url, { data: body });
  }

  detalleListadoCargaRetenedoresIVA(id) {
    let url = `${this.baseUrl}/retenedores/agentes/detalle/${id}`
    return this.axios.get(url);
  }



  DetalleCargaRetenedores(id) {
    let url = `${this.baseUrl}/agentes/detalle/${id}`
    return this.axios.get(url);
  }

  getUsuariosEstado() {
    let url = `${this.baseUrl}/usuario/estados`
    return this.axios.get(url);
  }

  GTMTOUSD(body) {
    let url = `${this.baseUrl}/cambio/moneda/GTMTOUSD`
    return this.axios.post(url, body);
  }

  putReasignarUsuario(body) {
    let url = `${this.baseUrl}/declaracion/reasignacion`
    return this.axios.put(url, body);
  }

  getUsuariosReasignacion() {
    let url = `${this.baseUrl}/declaracion/usuarios/reasignacion`
    return this.axios.get(url);
  }

  resuscribirAlusuario(body) {
    let url = `${this.baseUrl}/suscripcion/resub`
    return this.axios.post(url, body);
  }

  getSuscripcionActivaPorId(id) {
    let url = `${this.baseUrl}/suscripcion/actual/usuario/${id}`
    return this.axios.get(url);
  }

  getTokenTarjetaPorId(id) {
    let url = `${this.baseUrl}/usuario/token/${id}`
    return this.axios.get(url);
  }

  getEmisores() {
    let url = `${this.baseUrl}/emisor/listado`
    return this.axios.get(url);
  }

  postEmisor(body) {
    let url = `${this.baseUrl}/emisor/insertar`
    return this.axios.post(url, body);
  }

  updateEmisor(body) {
    let url = `${this.baseUrl}/emisor/actualizar`
    return this.axios.put(url, body);
  }

  deleteEmisor(body) {
    let url = `${this.baseUrl}/emisor/eliminar`
    return this.axios.delete(url, { data: body });
  }


  deleteTipo_emisor(body) {
    let url = `${this.baseUrl}/tipo_emisor/eliminar`
    return this.axios.delete(url, { data: body });
  }

  postTipoEmisor(body) {
    let url = `${this.baseUrl}/tipo_emisor/insertar`
    return this.axios.post(url, body)
  }

  getTipoEmisor() {
    let url = `${this.baseUrl}/tipo_emisor/listado`
    return this.axios.get(url);
  }


  getTipoEmisorActivos() {
    let url = `${this.baseUrl}/tipo_emisor/listado/activos`
    return this.axios.get(url);
  }

  updateTipoEmisor(body) {
    let url = `${this.baseUrl}/tipo_emisor/actualizar`
    return this.axios.put(url, body)
  }

  cargaMasivaEmisoresNIT(body) {
    let url = `${this.baseUrl}/emisor/carga`
    return this.axios.post(url, body)
  }

  getListadoActividadEconomica() {
    let url = `${this.baseUrl}/actividad_economica/listado`
    return this.axios.get(url);
  }

  getListadoActividadEconomicaActivos() {
    let url = `${this.baseUrl}/actividad_economica/listado/activos`
    return this.axios.get(url);
  }

  correo_masivo(body) {
    let url = `${this.baseUrl}/correo/masivo`
    return this.axios.post(url, body)
  }

  enviar_factura(body) {
    let url = `${this.baseUrl}/correo/facturacion`
    return this.axios.post(url, body)
  }

  getTipo_registro_listado() {
    let url = `${this.baseUrl}/tipo_registro/listado`
    return this.axios.get(url);
  }

  getTipo_registro_listado_activos() {

    // let url = `${this.baseUrl}/tipo_registro/listado/activos`
    // this.axios.get(url)
    //   .then(response => {
    //     console.log('Respuesta de la solicitud:', response.data); // Imprime la respuesta en la consola
    //     // Aquí puedes continuar haciendo otras operaciones con la respuesta si es necesario
    //   })
    //   .catch(error => {
    //     console.error('Error al hacer la solicitud:', error); // Maneja cualquier error que ocurra
    //     // Aquí puedes manejar el error de acuerdo a tus necesidades
    //   });

    let url2 = `${this.baseUrl}/tipo_registro/listado/activos`
    return this.axios.get(url2);
  }

  postTipo_registro_insertar(body) {
    let url = `${this.baseUrl}/tipo_registro/insertar`
    return this.axios.post(url, body);
  }

  putTipo_Registro_actualizar(body) {
    let url = `${this.baseUrl}/tipo_registro/actualizar`
    return this.axios.put(url, body);
  }

  deleteTipo_registro(body) {
    let url = `${this.baseUrl}/tipo_registro/eliminar`
    return this.axios.delete(url, { data: body });
  }

  getActividad_economica() {
    let url = `${this.baseUrl}/actividad_economica/listado`
    return this.axios.get(url);
  }

  postActividad_economica(body) {
    let url = `${this.baseUrl}/actividad_economica/insertar`
    return this.axios.post(url, body);
  }

  putActividad_economica(body) {
    let url = `${this.baseUrl}/actividad_economica/actualizar`
    return this.axios.put(url, body);
  }

  deleteActividad_economica(body) {
    let url = `${this.baseUrl}/actividad_economica/eliminar`
    return this.axios.delete(url, { data: body });
  }

  getPerfil_declaracion() {
    let url = `${this.baseUrl}/perfil_declaracion/listado`
    return this.axios.get(url);
  }

  postPerfil_declaracion(body) {
    let url = `${this.baseUrl}/perfil_declaracion/insertar`
    return this.axios.post(url, body);
  }

  putPerfil_declaracion(body) {
    let url = `${this.baseUrl}/perfil_declaracion/actualizar`
    return this.axios.put(url, body);
  }

  deletePerfil_declaracion(body) {
    let url = `${this.baseUrl}/perfil_declaracion/eliminar`
    return this.axios.delete(url, { data: body });
  }

  getTipo_dte_listado() {
    let url = `${this.baseUrl}/tipo_dte/listado`
    return this.axios.get(url);
  }

  postTipo_dte_insertar(body) {
    let url = `${this.baseUrl}/tipo_dte/insertar`
    return this.axios.post(url, body);
  }

  putTipo_dte_actualizar(body) {
    let url = `${this.baseUrl}/tipo_dte/actualizar`
    return this.axios.put(url, body);
  }

  deleteTipo_dte(body) {
    let url = `${this.baseUrl}/tipo_dte/eliminar`
    return this.axios.delete(url, { data: body });
  }


  insertar_fecha_declaracion(body) {
    let ruta = `${this.baseUrl}/fecha_declaracion/insertar`
    return this.axios.post(ruta, body);
  }

  modificar_fecha_declaracion(body) {
    let ruta = `${this.baseUrl}/fecha_declaracion/actualizar`
    return this.axios.put(ruta, body);
  }

  listado_fecha_declaracion() {
    let ruta = `${this.baseUrl}/fecha_declaracion/listado`
    return this.axios.get(ruta);
  }

  /*  dia_moviemiento_insertar() {
     let ruta = `${this.baseUrl}/dia_movimiento/insertar`
     return this.axios.post(ruta, body);
   } */

  dia_movimiento_listado() {
    let ruta = `${this.baseUrl}/dia_movimiento/listado`
    return this.axios.get(ruta);
  }

  dia_movimiento_actualizar(body) {
    let ruta = `${this.baseUrl}/dia_movimiento/actualizar`
    return this.axios.put(ruta, body);
  }

  getListadoEmisores(id) {
    let url = `${this.baseUrl}/emisor/listado/${id}`
    return this.axios.get(url);
  }

  // fecha limite iva retenedores
  getFechaLimiteIVA() {
    let url = `${this.baseUrl}/fecha_iva/listado`
    return this.axios.get(url);
  }

  insertarFechaLimiteIVA(body) {
    let url = `${this.baseUrl}/fecha_iva/insertar`
    return this.axios.post(url, body);
  }

  actualizarFechaLimiteIVA(body) {
    let url = `${this.baseUrl}/fecha_iva/actualizar`
    return this.axios.put(url, body);
  }

  // fecha limite isr retenedores
  getFechaLimiteISR() {
    let url = `${this.baseUrl}/fecha_isr/listado`
    return this.axios.get(url);
  }

  insertarFechaLimiteISR(body) {
    let url = `${this.baseUrl}/fecha_isr/insertar`
    return this.axios.post(url, body);
  }

  actualizarFechaLimiteISR(body) {
    let url = `${this.baseUrl}/fecha_isr/actualizar`
    return this.axios.put(url, body);
  }

  validarAgentesIVA(body) {
    let url = `${this.baseUrl}/agentes/iva/validar`
    return this.axios.post(url, body);
  }

  //get listado usuarios por regimen
  getListadoUsariosPorRegimen(regimen_id) {
    let url = `${this.baseUrl}/usuario/listado/declaracion/${regimen_id}`
    return this.axios.get(url);
  }

  // carga cortesia ros
  cargaMasivaCortesia(body) {
    let url = `${this.baseUrl}/carga/cortesia/ros/insert`
    return this.axios.post(url, body)
  }

  // reporte anual
  postReporteAnual(body) {
    let url = `${this.baseUrl}/cierre/anual`
    return this.axios.post(url, body);
  }

  apiTicLabsCa(body) {
    let url = `${this.baseUrl}/api-ticlabsca/login`
    return this.axios.get(url);
  }

  solicitarFacturasElectronicas(body) {
    let url = `${this.baseUrl}/libros/compras_ventas/solicitar`
    return this.axios.post(url, body);
  }

  cargarFacturasElectronicas(body) {
    let url = `${this.baseUrl}/libros/compras_ventas/mover`
    return this.axios.get(url);
  }

}

export default administradorService;